import { useSelector } from 'react-redux';

const useIsClusterManager = () => {
  const user = useSelector((state) => state.authSlice?.userData);
  return user?.learningRoles?.includes('TR_CLUSTER_MGR') || false;
};

export default useIsClusterManager;
// example usage
